import { Component, Inject, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationDialogData } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-confirm-batch-request-dialog',
  templateUrl: './confirm-batch-request-dialog.component.html',
  styleUrls: ['./confirm-batch-request-dialog.component.scss']
})
export class ConfirmBatchRequestDialogComponent implements OnInit {

  batchNumber = new FormControl('', Validators.required);
  constructor(
    public _dialogRef: MatDialogRef<ConfirmBatchRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) { }

  ngOnInit(): void {

  }

}
